module.exports = __webpack_public_path__ + "static/media/clcontact.9a0d4110.pdf";